import { LoaderFunctionArgs } from "@remix-run/cloudflare"
import { Outlet, useLoaderData } from "@remix-run/react"
import Footer from "~/components/footer"
import Header from "~/components/header"
import type { CloudflareENV } from "~/lib/interfaces"
import { getAuthenticator } from "~/services/auth"
import NotificationService from "~/services/db/notification"
import UserService from "~/services/db/user"

export async function loader({ request, context }: LoaderFunctionArgs) {
  const env = context.cloudflare.env as CloudflareENV
  const { authenticator } = getAuthenticator(env)
  const user = await authenticator.isAuthenticated(request)
  const UserDetail = user?.id ? await new UserService(env.DB).getById(user?.id) : null
  const notifications =
    user?.id &&
    (await new NotificationService(env.DB).getNotificationsByUserId({
      userId: user?.id
    }))

  return { user, notifications, UserDetail }
}

export default function AuthLayout() {
  const { user, UserDetail } = useLoaderData<typeof loader>()
  return (
    <div>
      <header>
        <Header user={UserDetail} />
      </header>
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
